module.exports = __webpack_public_path__ + "img/student_12.fda729ca.png";